export enum PAGES {
  HOME = 'home/:id',
  LANDING = 'landing',
  PAGE_NOT_FOUND = 'page-not-found',
  SESSION_EXPIRED = 'session-expired',
  LOGOUT = 'logout',
  NO_ACCESS = 'no-access',
  ENGAGEMENTDETAILS = 'engagementdetails/:name/:id',
  ASSET_LIBRARY = 'asset-library/:id',
  CONTRACTUAL_DOCS = 'contractual-docs/:id',
  GOVERNANCE_MEETINGS = 'governance-meetings',
  INNOVATION_PRODUCTIVITY = 'innovation-productivity/:id',
  TRANSITION_PAGE= 'transition-page',
  POWER_BI_DASHBOARD = 'power-bi-dashboard/:id/:name',
}
